import { motion } from "motion/react";
import { Icon } from "../icons";
import { type BaseButtonProps, Button } from "./button";

/** Props Interface */
interface CollapseButtonProps extends BaseButtonProps {
	onToggle: () => void;
	isOpen: boolean;
}

export function CollapseButton({ onToggle, isOpen, size = "xs", ...props }: CollapseButtonProps) {
	/** Render */
	return (
		<Button
			variant="ghost"
			icon={
				<motion.div animate={{ rotate: isOpen ? 90 : 0 }}>
					<Icon name="ChevronRight" />
				</motion.div>
			}
			onClick={onToggle}
			size={size}
			{...props}
		/>
	);
}
